export const modalReservationDirect = {
  header: {
    title: "Direkte Web-Buchungen",
    subtitle: "Legen Sie fest, was der Gast sieht und wie die Regeln gelten.",
  },
  tabs: {
    reservations: "Buchungsstatus",
    ratePlans: "Tarife",
    promotions: "Aktionen",
    addons: "Zusatzgebühren",
    payments: "Preise & Zahlungen",
    share: "Teilen",
  },
  common: {
    close: "Schließen",
    updating: "Wird aktualisiert…",
    hotel: "Hotel",
    apartment: "Apartment",
    visible: "Sichtbar",
    default: "Standard",
    dragToReorder: "Zum Sortieren ziehen",
    saving: "Wird gespeichert…",
    preview: "Vorschau",
  },
  toast: {
    successTitle: "Erfolg",
  },
  save: {
    ratePlans: "Tarife speichern",
    promotions: "Aktionen speichern",
    addons: "Gebühren speichern",
    default: "Speichern",
  },
  reservations: {
    cardTitle: "Status der Direktbuchung",
    cardDesc: "Verfügbarkeit für Direktbuchungen ein- oder ausschalten (global und pro Einheit).",
    activateTitle: "Direktbuchungen aktivieren",
    activateHelp: "Wenn dies aus ist, können Sie keine einzelnen Einheiten aktivieren.",
    colName: "Unterkunft / Einheit",
    colCapacity: "Kapazität",
    colAvailable: "Verfügbar",
    emptyUnits: "Für diese Unterkunft sind keine Einheiten konfiguriert.",
  },
  ratePlans: {
    title: "In der Direktbuchung angezeigte Tarife",
    hotelDesc: "Legen Sie fest, welche Tarife für jeden Zimmertyp angezeigt werden",
    apartmentDesc: "Wählen Sie, welche Tarife der Gast sieht, welcher der Standard ist und in welcher Reihenfolge",
    loading: "Tarife werden geladen…",
    emptyApartment: "Für diese Unterkunft sind keine Tarife konfiguriert.",
    emptyHotel: "Für dieses Hotel sind keine Zimmertypen konfiguriert.",
    emptyRoom: "Für dieses Zimmer sind keine Tarife konfiguriert.",
    colTarifa: "Tarif",
    colVisibleName: "Anzeigename",
    visibleNameTooltip: "Optionaler Name, der dem Gast angezeigt wird",
    namePlaceholderApartment: "z. B. Nicht erstattbar / Flexibel",
    namePlaceholderHotel: "z. B. Inklusive Frühstück",
    derivedBadge: "Abgeleitet",
    rulesApartment: "Regeln: mindestens 1 sichtbar und 1 Standard (der sichtbar sein muss).",
    rulesHotel: "Jedes Zimmer muss mindestens 1 sichtbaren Tarif und 1 Standardtarif haben.",
  },
  rooms: {
    ratesCount: "{count} Tarif | {count} Tarife",
    meta: "Kapazität: {capacity} • Erwachsene: {adults} • Kinder: {children}",
  },
  promotions: {
    title: "Aktionen in der Direktbuchung",
    desc: "Steuern Sie, welche angezeigt werden, ob sie automatisch gelten und in welcher Reihenfolge.",
    loading: "Aktionen werden geladen…",
    empty: "Für diese Unterkunft sind keine Aktionen konfiguriert.",
    colPromo: "Aktion",
    colBadge: "Badge",
    badgeTooltip: "Kurzer Text (z. B. -10 %, Deal, Early Bird).",
    colAuto: "Automatisch anwenden",
    colStackable: "Kombinierbar",
    badgePlaceholder: "z. B. -10 % / Deal",
    tip: "Tipp: Wenn eine Aktion den Endpreis nicht beeinflussen soll, schalten Sie „Automatisch anwenden“ aus und lassen Sie sie sichtbar.",
    fromDate: "Ab {date}",
    untilDate: "Bis {date}",
  },
  addons: {
    loading: "Einstellungen werden geladen…",
    subtabOccupancy: "Belegungsrabatt",
    subtabExtraGuest: "Gebühr für Zusatzgäste",
    baseOccupancyTitle: "Basisbelegung",
    baseOccupancyDesc: "Der übliche Preis entspricht dieser Belegung. Für weniger Gäste wenden Sie eine Ermäßigung an.",
    guestsLabel: "Gäste",
    headOccupancy: "Belegung",
    headRule: "Regel",
    headValue: "Wert",
    headActive: "Aktiv",
    guestWord: "Gast | Gäste",
    usualPrice: "Üblicher Preis",
    modePercent: "Ermäßigung %",
    modeFixed: "Feste Ermäßigung (pro Nacht)",
    occupancyExample: "Beispiel: Basis 4 Gäste und Rabatte für 3, 2 und 1.",
    configTitle: "Einstellungen",
    configDesc: "Wenden Sie einen Aufschlag für jeden Zusatzgast über der enthaltenen Belegung an.",
    activate: "Aktivieren",
    includedTitle: "Enthaltene Belegung",
    includedDesc: "Wird automatisch aus der Kapazität der Unterkunft übernommen.",
    maxExtraLabel: "Maximal erlaubte Zusatzgäste",
    maxHelpHtml: "Wie viele Gäste <b>zusätzlich zur enthaltenen Belegung</b> hinzugefügt werden können.<br />Bei <b>0</b> sind keine Zusatzgäste erlaubt.<br />Wenn Sie das Feld leer lassen, gibt es kein Limit.",
    chargeTypeLabel: "Gebührentyp",
    chargeTypeFixed: "Fester Betrag",
    chargeTypePercentage: "Prozentsatz",
    chargeTypeHelp: "Fest: {currency} pro Zusatzgast. Prozentsatz: % des Basispreises.",
    priceLabel: "Preis pro Zusatzgast",
    appliesHelp: "Wird pro Zusatzgast angewendet.",
    appliesBlockedNote: "(Keine Zusatzgäste erlaubt, wenn das Maximum 0 ist)",
    applicationLabel: "Anwendung",
    applicationNote: "Derzeit gilt diese Gebühr pro Nacht.",
    previewFixed: "Jeder Zusatzgast kostet <b>{amount}</b> pro Nacht.",
    previewPercent: "Jeder Zusatzgast kostet <b>{percent} %</b> des Basispreises pro Nacht.",
    singleValueNote: "Dies ist ein <b>einzelner Wert</b> (z. B. +10 {currency} oder +15 % pro Zusatzgast).",
  },
  payments: {
    title: "Preise & Zahlungen",
    desc: "Zahlungsart und Rabatte für Direktbuchungen.",
    paymentTypeTitle: "Zahlungsart",
    onArrivalLabel: "Zahlung bei Ankunft",
    onArrivalDesc: "Der Gast bucht und zahlt direkt bei der Ankunft.",
    onlineLabel: "Online-Zahlung",
    onlineDesc: "Der Gast zahlt online beim Abschluss der Buchung.",
    discountsTitle: "Rabatte",
    enableDiscount: "Rabatt auf Direktbuchungen aktivieren",
    discountTypeTitle: "Rabattart",
    typePercentage: "Prozentsatz",
    typePercentageDesc: "Rabatt anteilig zum Gesamtbetrag.",
    typeFixed: "Fest",
    typeFixedDesc: "Fester Betrag, der abgezogen wird.",
    valueTitle: "Wert",
    placeholderPercentage: "z. B. 10",
    placeholderFixed: "z. B. 15,00",
    helpPercentage: "Maximal 100 %. Wird auf den Gesamtbetrag angewendet.",
    helpFixed: "Ein fester Betrag wird in {currency} abgezogen.",
    previewPercentage: "Es wird ein Rabatt von {percent} % angewendet.",
    previewFixed: "Es wird ein Rabatt von {amount} angewendet.",
  },
  share: {
    title: "Teilen",
    desc: "Kopieren Sie den Direktbuchungslink und teilen Sie ihn auf WhatsApp oder öffnen Sie die Gastansicht.",
    linkLabel: "Buchungslink",
    linkHelp: "Diesen Link teilen Sie mit Ihren Gästen.",
    viewAsGuest: "Als Gast ansehen",
    tip: "Tipp: Teilen Sie diesen Link in Ihrer Bio, in automatischen Nachrichten und in Kampagnen.",
    whatsappMessage: "Hallo 👋 Hier ist der Link zum Buchen: {link}",
  },
  errors: {
    loadRatePlans: "Die Tarife konnten nicht geladen werden.",
    saveRatePlans: "Die Tarife konnten nicht gespeichert werden.",
    roomMinVisible: 'Zimmer "{name}" muss mindestens 1 sichtbaren Tarif haben.',
    roomExactlyOneDefault: 'Zimmer "{name}" muss genau 1 Standardtarif haben.',
    roomDefaultMustBeVisible: 'In "{name}" muss der Standardtarif sichtbar sein.',
    aptMinVisible: "Sie müssen mindestens 1 sichtbaren Tarif behalten.",
    aptExactlyOneDefault: "Es muss genau 1 Standardtarif geben.",
    aptDefaultMustBeVisible: "Der Standardtarif muss sichtbar sein.",
    loadPromotions: "Die Aktionen konnten nicht geladen werden.",
    savePromotions: "Die Aktionen konnten nicht gespeichert werden.",
    saveAddons: "Die Zusatzgebühren konnten nicht gespeichert werden.",
    maxExtraRange: "Die maximale Zahl an Zusatzgästen muss zwischen 0 und 50 liegen (oder leer = kein Limit).",
    extraPriceInvalid: "Der Preis pro Zusatzgast muss gültig sein (>= 0).",
    percentRange: "Der Prozentsatz muss zwischen 0 und 100 liegen.",
    baseOccupancyRange: "Die Basisbelegung muss zwischen 1 und {max} liegen.",
    discountValuesInvalid: "Die Rabattwerte müssen gültige Zahlen sein (>= 0).",
    discountPercentMax: "Prozentuale Rabatte dürfen 100 nicht überschreiten.",
    updateFailed: "Aktualisierung nicht möglich.",
    updateUnitFailed: "Der Status der Einheit konnte nicht aktualisiert werden.",
    updateGlobalFailed: "Der globale Status konnte nicht aktualisiert werden.",
    noLinkCopy: "Kein Link zum Kopieren.",
    copyFailed: "Der Link konnte nicht kopiert werden.",
    noLinkShare: "Kein Link zum Teilen.",
    noLinkOpen: "Kein Link zum Öffnen.",
    updatePaymentType: "Die Zahlungsart konnte nicht aktualisiert werden.",
    savePayments: "Die Änderungen konnten nicht gespeichert werden.",
  },
  success: {
    ratePlansSaved: "Tarife erfolgreich gespeichert.",
    promotionsSaved: "Aktionen erfolgreich gespeichert.",
    addonsSaved: "Zusatzgebühren erfolgreich gespeichert.",
    updated: "Erfolgreich aktualisiert.",
    globalUpdated: "Globaler Status aktualisiert.",
    linkCopied: "Link kopiert.",
    changesSaved: "Änderungen gespeichert.",
  },
};
